<div class="card">
  <form [formGroup]="designForm" (ngSubmit)="onSubmit(designForm)">
    <div class="card-header font-weight-bold">
      <div class="row justify-content-between align-items-center">
        <div class="form_head col-12 col-sm-12 col-md-7 col-lg-11 col-xl-11">
          <h2>
            <span>Design</span>
          </h2>
        </div>
        <div class="col-12 col-sm-12 col-md-5 col-lg-1 col-xl-1">
          <div class="text-left text-md-right">
            <button
              type="submit"
              class="btn btn-primary btn-block"
              [disabled]="userPermissions.design_setting.view && !userPermissions.design_setting.edit">
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-sm-6">
          <fieldset [disabled]="userPermissions.design_setting.view && !userPermissions.design_setting.edit">
            <div class="row">
              {{ message }}

              <div class="col-sm-12">
                <div class="img_uplo_box_Mainb">
                  <div class="img_uplo_box">
                    <img src="{{ egan_hub_site_logo }}" id="site_logo_preview" class="" />
                  </div>
                </div>
                <div class="upload_dkl">
                  <div class="file btn btn-lg">
                    Upload logo<input
                      type="file"
                      name="egan_hub_site_logo"
                      id="site_logo_inp"
                      #site_log_inp
                      accept="image/*"
                      (change)="onFileSelect($event, 'egan_hub_site_logo')" />
                  </div>
                  <p>
                    You can upload only .png, .jpg, .gif files, no more than 1MB, height must be less than equal to
                    40px.
                  </p>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="img_uplo_box_Mainb">
                  <div class="img_uplo_box img_uplo_box_favi">
                    <img src="{{ egan_hub_favicon }}" id="site_favicon_preview" class="" />
                  </div>
                </div>
                <div class="upload_dkl">
                  <div class="file btn btn-lg">
                    Upload Favicon<input
                      type="file"
                      name="egan_hub_favicon"
                      id="site_favicon_inp"
                      accept="image/*, .ico"
                      #site_favicon_inp
                      (change)="onFileSelect($event, 'egan_hub_favicon')" />
                  </div>
                  <p>You can upload only .png, .jpg, .gif, .ico files, no more than 1MB</p>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
        <div class="col-sm-6 padsecnwe">
          <fieldset [disabled]="userPermissions.design_setting.view && !userPermissions.design_setting.edit">
            <div class="form-group mrgBM15">
              <div class="row">
                <div class="col-sm-3">
                  <label>Primary Color<sup>*</sup></label>
                </div>
                <div class="col-sm-9">
                  <!-- <input type="hidden" formContorlName="primary_color" class="form-control primary_color"> -->
                  <div class="input-group mb-3 colorpicker">
                    <input
                      type="text"
                      id="val1"
                      class="form-control"
                      [value]="egan_hub_primary_color1"
                      #val1
                      (change)="changeVal(val1.value)" />
                    <div class="input-group-append">
                      <button
                        class="input-group-addon"
                        id="val2"
                        data-jscolor="{valueElement:'val1',uppercase:false,hash:true}">
                        <i></i>
                      </button>
                    </div>
                  </div>
                  <span
                    class="error"
                    *ngIf="
                      designForm.get('egan_hub_primary_color').hasError('required') &&
                      designForm.get('egan_hub_primary_color').touched
                    ">
                    Please select primary color
                  </span>
                </div>
              </div>
            </div>
            <div class="form-group mrgBM15">
              <div class="row">
                <div class="col-sm-3">
                  <label>Site Title<sup>*</sup></label>
                </div>
                <div class="col-sm-9">
                  <input type="text" class="form-control" formControlName="egan_hub_site_title" />
                  <span
                    class="error"
                    *ngIf="
                      designForm.get('egan_hub_site_title').hasError('required') &&
                      designForm.get('egan_hub_site_title').touched
                    ">
                    Please provide site title
                  </span>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </div>
  </form>
</div>
